"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverArrow = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PopoverArrowMixin = require("../../mixins/components/PopoverArrowMixin");
/**
 * A helper for the `Popover` component.
 *
 * @since 7.0.0
 */
var PopoverArrow = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "PopoverArrow",
  componentId: "c11n-8-107-0__sc-ji6mam-0"
})(["", ""], _PopoverArrowMixin.PopoverArrowMixin);
exports.PopoverArrow = PopoverArrow;
PopoverArrow.displayName = 'PopoverArrow';

/** @component */